import { useState } from 'react';

export function useContactSupport() {
  const [open, setOpen] = useState(false);

  const openSupport = () => setOpen(true);
  const closeSupport = () => setOpen(false);

  return {
    open,
    openSupport,
    closeSupport,
  };
}
